import React from 'react';
import { TrendingUpIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 border-t border-slate-800 mt-20" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-19">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-20">
          <div className="col-span-1 md:col-span-2" data-id="element-21">
            <div className="flex items-center gap-2 mb-4" data-id="element-22">
              <TrendingUpIcon size={28} className="text-blue-400" data-id="element-23" />
              <span className="font-bold text-xl text-white" data-id="element-24">
                CryptoTopReviews
              </span>
            </div>
            <p className="text-slate-400 leading-relaxed" data-id="element-25">
              Your trusted source for cryptocurrency and exchange reviews. We
              provide comprehensive intelligence to help you make informed
              decisions in the crypto space.
            </p>
          </div>

          <div data-id="element-26">
            <h3 className="font-semibold text-white mb-4" data-id="element-27">Resources</h3>
            <ul className="space-y-2" data-id="element-28">
              <li data-id="element-29">
                <a href="#" className="hover:text-white transition-colors" data-id="element-30">
                  Top Cryptocurrencies
                </a>
              </li>
              <li data-id="element-31">
                <a href="#" className="hover:text-white transition-colors" data-id="element-32">
                  Top Exchanges
                </a>
              </li>
              <li data-id="element-33">
                <a href="#" className="hover:text-white transition-colors" data-id="element-34">
                  Reviews
                </a>
              </li>
              <li data-id="element-35">
                <a href="#" className="hover:text-white transition-colors" data-id="element-36">
                  About Us
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-37">
            <h3 className="font-semibold text-white mb-4" data-id="element-38">Legal</h3>
            <ul className="space-y-2" data-id="element-39">
              <li data-id="element-40">
                <a href="#" className="hover:text-white transition-colors" data-id="element-41">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="hover:text-white transition-colors" data-id="element-43">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" className="hover:text-white transition-colors" data-id="element-45">
                  Disclaimer
                </a>
              </li>
              <li data-id="element-46">
                <a href="#" className="hover:text-white transition-colors" data-id="element-47">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-slate-500" data-id="element-48">
          <p data-id="element-49">&copy; 2024 CryptoTopReviews.com. All rights reserved.</p>
          <p className="mt-2 text-sm" data-id="element-50">
            Cryptocurrency investments carry risk. Always do your own research.
          </p>
        </div>
      </div>
    </footer>;
}